import React from 'react'
import { Link } from 'gatsby'
import AniLink from 'gatsby-plugin-transition-link/AniLink'

import { Grid, Typography } from '@material-ui/core'
import { Button } from '..'

import useStyles from './styles'

const CTA = ({
  btnText,
  linkText,
  btnAction,
  btnRoute,
  linkRoute,
  isExternal,
  icon,
}) => {
  const { ctaRoot, link, btnWrapper, linkWrapper, linkButton } = useStyles()
  return (
    <Grid container className={ctaRoot}>
      {btnText && (
        <Grid item className={btnWrapper}>
          {isExternal ? (
            <a
              className={linkButton}
              href={btnRoute}
              target="_blank"
              rel="noopener noreferrer"
            >
              {btnText}
            </a>
          ) : btnRoute ? (
            <Link to={btnRoute} duration={1} style={{ textDecoration: 'none' }}>
              <div
                className={linkButton}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {icon && icon}
                <div style={{ marginLeft: 8, textDecoration: 'none' }}>
                  {btnText}
                </div>
              </div>
            </Link>
          ) : (
            <Button handleClick={btnAction}>{btnText}</Button>
          )}
        </Grid>
      )}
      {linkText && (
        <Grid item className={linkWrapper}>
          <AniLink fade to={linkRoute} className={link}>
            <Typography component="span">{linkText}</Typography>
          </AniLink>
        </Grid>
      )}
    </Grid>
  )
}

export default CTA
